module.exports = __webpack_public_path__ + "static/media/arrow-from-right.d875e520.svg";